import React from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import Field from 'core/components/form/form.v2';
import AddressAutocomplete from 'core/components/address-autocomplete/address-autocomplete';

export const residenceInitialValues = {
  description: '',
  address: {
    address: '',
    address2: '',
    city: '',
    state: '',
    zip: ''
  },
  numFamilies: undefined
};

export const residenceValidationSchema = Yup.object().shape({
  description: Yup.string().required('Item name is required'),
  address: Yup.object().shape({
    address: Yup.string().required('Address is required'),
    city: Yup.string().required('City is required'),
    state: Yup.string().required('State is required'),
    zip: Yup.string().required('ZIP is required')
  })
});

const NotOnPolicyResidence = ({ disabled }) => {
  return (
    <>
      <Field
        xs={12}
        type="string"
        name="description"
        mode="dark"
        label="Item name*"
        helperText="Give this item a small name for reference"
        disabled={disabled}
      />
      <AddressAutocomplete
        id="address.address"
        name="address.address"
        xs={6}
        mode="dark"
        label="Address*"
        disabled={disabled}
      />
      <Field
        xs={6}
        type="string"
        name="address.address2"
        mode="dark"
        label="Apt, unit, building, etc."
        disabled={disabled}
      />
      <Field xs={4} type="string" name="address.city" mode="dark" label="City*" disabled={disabled} />
      <Field xs={4} type="state" name="address.state" mode="dark" label="State*" disabled={disabled} />
      <Field xs={4} type="string" name="address.zip" mode="dark" label="Zip code*" disabled={disabled} />
      <Field xs={12} type="numeric" name="numFamilies" mode="dark" label="Families living" disabled={disabled} />
    </>
  );
};

NotOnPolicyResidence.propTypes = {
  disabled: PropTypes.bool.isRequired
};

export default NotOnPolicyResidence;
